<template>
  <div class="mam-sub-right-account-header white mar-bot10 border-radius5">
    <div class="nickname-line">
      <span class="nickname-title">{{alias}}</span>
      <span class="mam-title copytype-title tag fs12">{{'MAM'}} {{'投资'}}</span>
    </div>
    <account-index-data-new
      @send-indexdata="sendIndexDataHandle"
    ></account-index-data-new>
  </div>
</template>

<script>
import accountIndexDataNew from "@/components/common/accountIndexDataNew";
import {getTraderOverview} from "@/api/copy";
export default {
  name: "mamSubrightBar",
  components: {
    accountIndexDataNew
  },
  data() {
    return {
      alias: '',
    }
  },
  created(){
    this.getOverView();
  },
  methods: {
    sendIndexDataHandle(accountInfo){
      this.$emit('send-indexdata', accountInfo);
    },
    getOverView(){
      getTraderOverview({
        mtId: this.$route.params.mtid,
      }).then((res) => {
        this.alias = res.data.alias;

      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mam-sub-right-account-header {
  padding: 30px;
  padding-bottom: 10px;
  .nickname-line {
    margin-bottom: 10px;
  }
  .nickname-title {
    display: inline-block;
    margin-right: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  .tag {
    background-color: rgba(255,127,90, .1);
    color: #FF7F5A;
  }
}
</style>
